import { c as _c } from "react/compiler-runtime";
interface AllIconProps {
  className?: string;
  size?: number;
}
const AllIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const t2 = `dynamic-size ${className}`;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M23 17H17V23H11V17H5V11H11V5H17V11H23" fill="currentColor" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t2 || $[4] !== t4) {
    t6 = <svg className={t2} style={t4} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">{t5}</svg>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default AllIcon;